import ServiceCard from "./ServiceCard";
import { useSiteContent } from "../../../context/SiteContentContext";

export default function CoolingSection() {
  const { content } = useSiteContent();
  const services = content.services_cooling;
  return (
    <section id="cooling" className="w-full relative overflow-hidden">
      {/* Full-bleed image header */}
      <div className="w-full relative overflow-hidden" style={{ height: "280px" }}>
        <img
          src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1600&h=560&fit=crop&q=85"
          alt="Cooling Systems"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(135deg,rgba(45,122,181,0.85) 0%,rgba(74,159,212,0.6) 50%,rgba(45,122,181,0.4) 100%)" }} />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to bottom,transparent 0%,rgba(45,122,181,0.95) 100%)" }} />
        <div className="absolute bottom-8 left-8 md:left-16">
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest mb-3"
            style={{ background: "rgba(255,255,255,0.15)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)", backdropFilter: "blur(8px)" }}
          >
            <i className="ri-temp-cold-line"></i>
            Our Services
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
            Cooling <span style={{ color: "rgba(255,255,255,0.65)" }}>Systems</span>
          </h2>
        </div>
      </div>

      {/* Cards area */}
      <div
        className="w-full relative overflow-hidden"
        style={{ background: "linear-gradient(135deg,#2d7ab5 0%,#4a9fd4 50%,#3a8ec4 100%)" }}
      >
        {/* Dot pattern */}
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: "radial-gradient(circle,rgba(255,255,255,0.07) 1px,transparent 1px)", backgroundSize: "28px 28px" }} />

        <div className="max-w-6xl mx-auto px-8 py-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between mb-10 gap-4">
            <p className="text-white/70 max-w-lg text-sm leading-relaxed">
              State-of-the-art cooling solutions engineered for maximum efficiency and comfort across all building types in New York City.
            </p>
            <a
              href="#easy"
              onClick={(e) => { e.preventDefault(); document.querySelector("#easy")?.scrollIntoView({ behavior: "smooth" }); }}
              className="flex items-center gap-2 text-sm font-bold whitespace-nowrap cursor-pointer transition-all hover:gap-3 text-white/80 hover:text-white"
            >
              Get a quote <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {services.map((s) => (
              <ServiceCard key={s.title} {...s} variant="blue" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
